import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, db } from '../firebase/config';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

const AffiliateContext = createContext({
  affiliateData: null,
  loading: true,
  error: null,
});

export const useAffiliate = () => {
  const context = useContext(AffiliateContext);
  if (!context) {
    throw new Error('useAffiliate must be used within an AffiliateProvider');
  }
  return context;
};

export const AffiliateProvider = ({ children }) => {
  const [affiliateData, setAffiliateData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const docRef = doc(db, 'affiliates', user.uid);
          const docSnap = await getDoc(docRef);
          
          if (docSnap.exists()) {
            setAffiliateData(docSnap.data());
          } else {
            setError('No affiliate data found');
          }
        } catch (err) {
          setError(err.message);
        }
      } else {
        setAffiliateData(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const value = {
    affiliateData,
    loading,
    error,
  };

  return (
    <AffiliateContext.Provider value={value}>
      {children}
    </AffiliateContext.Provider>
  );
};

export default AffiliateContext;
